<template>
	<div class="page" v-loading="loadingPage">
		<div class="page-title bg-white padding-lr flex justify-between align-center shadow-warp border-bottom">
			<div class="text-lg text-bold">
				<i class="el-icon-caret-right"></i>
				{{ $route.meta.title }}
			</div>
			<el-button type="success" round size="small" @click="dialogVisibleAdd = true">
				<span class="el-icon-plus"></span>
				创建新联系人
			</el-button>
		</div>
		<div class="page-main">
			<el-card class="box-card">
				<div slot="header" class="flex justify-between align-center">
					<div>
						<span class="el-icon-search"></span>
						<span class="text-bold margin-left-sm">信息检索</span>
					</div>
				</div>
				<el-form :inline="true" :model="formSearch" class="demo-form-inline" label-suffix=":">
					<el-form-item label="姓名"><el-input v-model="formSearch.data.name" clearable placeholder="联系人姓名"></el-input></el-form-item>
					<el-form-item label="手机"><el-input v-model="formSearch.data.mobile" clearable placeholder="手机号码"></el-input></el-form-item>
					<el-form-item label="状态">
						<el-select v-model="formSearch.data.stateflag" clearable placeholder="状态" style="width: 120px;">
							<el-option label="有效" :value="1"></el-option>
							<el-option label="无效" :value="0"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="创建时间">
						<el-date-picker
							v-model="formSearch.data.addtime"
							type="daterange"
							range-separator="至"
							start-placeholder="开始日期"
							end-placeholder="结束日期"
							value-format="yyyy-MM-dd"
						></el-date-picker>
					</el-form-item>
					<el-form-item><el-button type="primary" @click="getInfoList">查询</el-button></el-form-item>
				</el-form>
			</el-card>
			<el-card class="box-card margin-top" :body-style="{ padding: '0px' }">
				<el-table :data="tableData.infos" style="width: 100%" stripe element-loading-text="加载中..." element-loading-spinner="el-icon-loading" v-loading="loading">
					<el-table-column type="index" align="center" label="序号" width="60"></el-table-column>
					<el-table-column prop="name" align="center" label="姓名"></el-table-column>
					<el-table-column prop="gender" align="center" label="性别">
						<template slot-scope="scope">
							<span class="cu-tag sm light bg-blue radius" v-if="scope.row.gender == 1">先生</span>
							<span class="cu-tag sm light bg-pink radius" v-else-if="scope.row.gender == 2">女士</span>
							<span class="cu-tag sm light bg-grey radius" v-else>未知</span>
						</template>
					</el-table-column>
					<el-table-column prop="mobile" align="center" label="手机"></el-table-column>
					<el-table-column prop="qq" align="center" label="QQ"></el-table-column>
					<el-table-column prop="weixin" align="center" label="微信"></el-table-column>
					<el-table-column prop="customer" align="center" label="关联客户">
						<template slot-scope="scope">
							<el-tag type="primary" size="mini" round>{{ scope.row.customer }}</el-tag>
						</template>
					</el-table-column>
					<el-table-column prop="stateflag" align="center" label="状态">
						<template slot-scope="scope">
							<el-tag type="success" size="mini" round v-if="scope.row.stateflag == 1">有效</el-tag>
							<el-tag type="info" size="mini" round v-else>无效</el-tag>
						</template>
					</el-table-column>
					<el-table-column prop="addtime" align="center" label="创建时间"></el-table-column>
					<el-table-column prop="updatetime" align="center" label="最后更新"></el-table-column>
					<el-table-column prop="name" align="center" label="选择" width="100">
						<template slot-scope="scope">
							<router-link :to="'/crm/contacter/view/' + scope.row.id ">
								<el-button size="small" type="primary">
									<i class="el-icon-view"></i>
									查看
								</el-button>
							</router-link>
						</template>
					</el-table-column>
				</el-table>
				<div class="padding-tb text-right">
					<el-pagination
						background
						@size-change="pageSizeChange"
						@current-change="pageChange"
						:current-page="tableData.page"
						:page-sizes="[10, 20, 50, 100]"
						:page-size="formSearch.size"
						layout="total, sizes, prev, pager, next, jumper"
						:total="tableData.total"
					></el-pagination>
				</div>
			</el-card>
			<el-dialog
				title="创建联系人"
				:close-on-click-modal="false"
				:close-on-press-escape="false"
				append-to-body
				:visible.sync="dialogVisibleAdd"
				width="500px"
				:show-close="false"
				top="10vh"
			>
				<div slot="title" class="flex align-center justify-between">
					<div class="flex align-center">
						<span class="iconfont-lianxiren text-gray text-xxl"></span>
						<div class="margin-left-xs"><div class="text-bold">创建联系人</div></div>
					</div>
					<el-link :underline="false" type="info" @click="dialogVisibleAdd = false"><i class="el-icon-close text-xxl"></i></el-link>
				</div>
				<div v-loading="loadingAdd" element-loading-text="处理中">
					<div class="padding-lr-xxl padding-tb" v-if="!contacterAddVisible">
						<div class="padding-tb text-lg text-grey">
							<i class="el-icon-info"></i>
							<span class="margin-left-xs">请输入手机号码：</span>
						</div>
						<el-input v-model="formAdd.mobile" placeholder="手机号码" autocomplete="off"></el-input>
						<div class="text-center margin-top-xl">
							<el-button type="primary" round @click="checkContacterMobile"><span>确认</span></el-button>
						</div>
					</div>
					<div class="padding-right margin-bottom-lg" style="max-height: 500px; overflow: auto;" v-else>
						<el-form ref="formAdd" :model="formAdd" label-width="60px" label-suffix=":">
							<el-form-item label="姓名" prop="name" :rules="{ required: true, message: '请输入姓名', trigger: 'blur' }">
								<el-input v-model="formAdd.name" placeholder="姓名" autocomplete="off"></el-input>
							</el-form-item>
							<el-form-item label="性别" prop="gender">
								<el-radio-group v-model="formAdd.gender">
									<el-radio :label="1">男</el-radio>
									<el-radio :label="2">女</el-radio>
									<el-radio :label="0">未知</el-radio>
								</el-radio-group>
							</el-form-item>
							<el-form-item label="固话" prop="telephone"><el-input v-model="formAdd.telephone" placeholder="固定电话" autocomplete="off"></el-input></el-form-item>
							<el-form-item label="手机" prop="mobile" :rules="{ required: true, message: '请输入手机号码', trigger: 'blur' }">
								<el-input v-model="formAdd.mobile" disabled placeholder="手机号码" autocomplete="off"></el-input>
							</el-form-item>
							<el-form-item label="email" prop="email"><el-input v-model="formAdd.email" placeholder="Email 地址" autocomplete="off"></el-input></el-form-item>
							<el-form-item label="QQ" prop="qq"><el-input v-model="formAdd.qq" placeholder="QQ号码" autocomplete="off"></el-input></el-form-item>
							<el-form-item label="微信" prop="weixin"><el-input v-model="formAdd.weixin" placeholder="微信号码" autocomplete="off"></el-input></el-form-item>
							<el-form-item label="备注" prop="remark">
								<el-input type="textarea" :autosize="{ minRows: 5, maxRows: 10 }" placeholder="备注信息" v-model="formAdd.remark"></el-input>
							</el-form-item>
						</el-form>
					</div>
					<div slot="footer" class="padding-left-xl padding-top border-top" v-if="contacterAddVisible">
						<el-button type="primary" @click="formSubmitAdd">保存提交</el-button>
						<el-button @click="clearFormAdd">清 除</el-button>
					</div>
				</div>
			</el-dialog>
		</div>
	</div>
</template>

<script>
export default {
	data() {
		return {
			loadingPage: false,
			searchData: {
				deptAndEmpTreeList: []
			},
			formSearch: {
				page: 1,
				size: 20,
				data: {}
			},
			tableData: {
				total: 0,
				page: 1,
				size: 20,
				infos: []
			},
			loading: false,
			dialogVisibleAdd: false,
			contacterAddVisible:false,
			loadingAdd: false,
			formAdd: {
				gender: 0,
				stateflag: 1
			},
			loadingCustomer: false,
			noMatchText: '',
			dataCustomer: [],
			dialogVisibleModify: false,
			loadingModify: false,
			formModify: {
				gender: 0,
				stateflag: 1
			}
		};
	},
	beforecreate: function() {},
	created: function() {
		this.getInfoList();
	},
	mounted: function() {},
	updated: function() {},
	methods: {
		userCard_show(id) {
			this.popover_id = id;
		},
		getInfoList() {
			var that = this;
			this.loading = true;
			this.$http.post('/server/index.php?m=crm/contacter&a=list', this.formSearch).then(
				res => {
					this.loading = false;
					if (res.result == 'ok') {
						this.tableData = res.data;
					} else {
						this.$alert(res.msg, {
							title: '操作错误',
							type: 'error'
						});
					}
				},
				r => {
					this.loading = false;
					this.$alert('网络错误，指定的服务无法访问。', {
						title: '系统错误',
						type: 'error'
					});
				}
			);
		},
		pageChange(page) {
			this.formSearch.page = page;
			this.getInfoList();
		},
		pageSizeChange(size) {
			this.formSearch.size = size;
			this.getInfoList();
		},
		checkContacterMobile() {
			if (!this.formAdd.mobile) {
				this.$message.error({
					message: '请填写手机号码',
					offset: 200
				});
				return false;
			}
			let myreg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;
			if (!myreg.test(this.formAdd.mobile)) {
				this.$message.error({
					message: '请填写正确的手机号码',
					offset: 200
				});
				return false;
			}
			this.loadingAdd = true;
			this.$http.post('/server/index.php?m=crm/contacter&a=checkMobile', { mobile: this.formAdd.mobile }).then(
				res => {
					this.loadingAdd = false;
					if (res.result == 'ok') {
						this.$message({
							message: '该手机号还未添加，请填写联系人信息',
							offset: 200
						});
						this.contacterAddVisible = true;
					} else {
						this.$confirm('系统中已经存在【' + this.formAdd.mobile + '（' + res.data.name + '）】。', '手机号已存在', {
							dangerouslyUseHTMLString: true,
							confirmButtonText: '确定',
							cancelButtonText: '取消',
							type: 'warning'
						});
					}
				},
				r => {
					this.loadingAdd = false;
					this.$alert('网络错误，指定的服务无法访问。', {
						title: '系统错误',
						type: 'error'
					});
				}
			);
		},
		formSubmitAdd() {
			this.$refs['formAdd'].validate(valid => {
				if (valid) {
					this.loadingAdd = true;
					this.$http.post('/server/index.php?m=crm/contacter&a=add', this.formAdd).then(
						res => {
							this.loadingAdd = false;
							if (res.result == 'ok') {
								this.$message({
									message: '联系人新建成功',
									type: 'success'
								});
								this.dialogVisibleAdd = false;
								this.getInfoList();
							} else {
								this.$alert(res.msg, {
									title: '操作错误',
									type: 'error'
								});
							}
						},
						r => {
							this.loadingAdd = false;
							this.$alert('网络错误，指定的服务无法访问。', {
								title: '系统错误',
								type: 'error'
							});
						}
					);
				}
			});
		},
		modifyContacter(contacter) {
			this.formModify = contacter;
			this.dialogVisibleModify = true;
		},
		formSubmitModify() {
			this.$refs['formModify'].validate(valid => {
				if (valid) {
					this.loadingModify = true;
					this.$http.post('/server/index.php?m=crm/contacter&a=modify', { data: this.formModify }).then(
						res => {
							this.loadingModify = false;
							if (res.result == 'ok') {
								this.$message({
									message: '修改联系人信息成功',
									type: 'success'
								});
								this.dialogVisibleModify = false;
								this.getInfoList();
							} else {
								this.$alert(res.msg, {
									title: '操作错误',
									type: 'error'
								});
							}
						},
						r => {
							this.loadingModify = false;
							this.$alert('网络错误，指定的服务无法访问。', {
								title: '系统错误',
								type: 'error'
							});
						}
					);
				} else {
					this.$alert('请根据红色提示填写。', {
						title: '表单错误',
						type: 'error'
					});
				}
			});
		},
		getInfosCustomer(keyword) {
			this.loading_customer = true;
			this.$http.post('/server/index.php?m=crm/contacter&a=getInfosCustomerByKeyword', { data: { keyword: keyword } }).then(
				res => {
					this.loading_customer = false;
					if (res.result == 'ok') {
						this.dataCustomer = res.data.infos;
					} else {
						this.noMatchText = res.msg;
					}
				},
				r => {
					this.loading_customer = false;
					this.noMatchText = '网络错误，指定的服务无法访问。';
				}
			);
		}
	}
};
</script>

<style></style>
